module.exports = __webpack_public_path__ + "img/1.55c9d276.png";